import type { FirebaseConfig } from '@zealth/core/firebase/runtime'

const parseEmulatorPort = (value: string | undefined): number | undefined => {
  const port = Number(value)
  return value && Number.isInteger(port) && port > 0 ? port : undefined
}

const config: FirebaseConfig = {
  options: {
    apiKey: import.meta.env.VITE_FIREBASE_API_KEY,
    authDomain: import.meta.env.VITE_FIREBASE_AUTH_DOMAIN,
    projectId: import.meta.env.VITE_FIREBASE_PROJECT_ID,
    appId: import.meta.env.VITE_FIREBASE_APP_ID,
  },
  firestore: {
    databaseId: import.meta.env.VITE_FIRESTORE_DATABASE_ID,
  },
  emulators: {
    enabled: import.meta.env.VITE_FIREBASE_USE_EMULATORS === 'true',
    // Ports default to the dev emulators (see core runtime). e2e runs override
    // these so the isolated test emulators (firebase.test.json) never clash
    // with the dev emulators running on the standard ports.
    authPort: parseEmulatorPort(
      import.meta.env.VITE_FIREBASE_EMULATOR_AUTH_PORT
    ),
    firestorePort: parseEmulatorPort(
      import.meta.env.VITE_FIREBASE_EMULATOR_FIRESTORE_PORT
    ),
  },
}

export default config
